import { combineReducers } from 'redux'
import userReducer from './userReducer'
import imagesReducer from './imagesReducer'
import requestReducer from './requestReducer'
import adminReducer from './adminReducer'
import requestListReducer from './requestListReducer'

export default combineReducers({
    user: userReducer,
    images: imagesReducer,
    request: requestReducer,
    admin: adminReducer,
    requestList: requestListReducer
})